module.exports = __webpack_public_path__ + "static/media/Travel.3d3ff5cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/share/Travel.png
// module id = 378
// module chunks = 0